export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11497.fa0875ed.jpg";